import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { fetchData } from '../../hooks/fetchData';
////

export const fetchProfilesThunk = createAsyncThunk(
  'profiles/fetch',
  async (deviceToken, thunkAPI) => {
    try {
      const response = await fetchData(
        `profiles`,
        'get',
        null,
        { 'devicetoken': deviceToken }
      );
      return thunkAPI.fulfillWithValue(response.data.data.profiles);

    } catch (err) {
      return thunkAPI.rejectWithValue();
    }
  }
);
export const createProfileThunk = createAsyncThunk(
  'profiles/create',
  async (profileData, thunkAPI) => {
    try {
      const response = await fetchData('profiles', 'post', profileData);
      const { responseData } = response.data.data;

      return thunkAPI.fulfillWithValue({responseData});
    } catch (err) {
      return thunkAPI.rejectWithValue(err);
    }
  }
);
export const deleteProfileThunk = createAsyncThunk(
  'profiles/delete',
  async ({profileId, deviceToken}, thunkAPI) => {
    try {
      await fetchData(`profiles/${profileId}`, 'delete',null,  {deviceToken: deviceToken});
      return thunkAPI.fulfillWithValue(profileId);
    } catch (err) {
      return thunkAPI.rejectWithValue();
    }
  }
);
export const updateProfileThunk = createAsyncThunk(
  'profiles/update',
  async ({ _id, avatar, nickName, age }, thunkAPI) => {
    try {
      await fetchData(`profiles/${_id}`, 'put', { _id, nickName, avatar, age });
      return thunkAPI.fulfillWithValue({ _id });
    } catch (err) {
      return thunkAPI.rejectWithValue();
    }
  }
);

export const updateGift = createAsyncThunk(
  'profiles/gifts',
  async ({ _id, count }, thunkAPI) => {
    try {
      await fetchData(`profiles/gift_use/${_id}`, 'put', { _id, count });
      return thunkAPI.fulfillWithValue({ _id });
    } catch (err) {
      return thunkAPI.rejectWithValue();
    }
  }
);

export const addGift = createAsyncThunk(
  'profiles/gifts',
  async ({ _id, count }, thunkAPI) => {
    try {
      await fetchData(`profiles/gift_add/${_id}`, 'post', { _id, count });
      return thunkAPI.fulfillWithValue({ _id });
    } catch (err) {
      return thunkAPI.rejectWithValue();
    }
  }
);
////

export const getUserDataThunk = createAsyncThunk(
  'user/data',
  async ({ userId }, thunkAPI) => {
    try {
      const response = await fetchData(`user/${userId}`, 'get', {});
      return thunkAPI.fulfillWithValue(response.data);
    } catch (err) {
      return thunkAPI.rejectWithValue();
    }
  },
);

export const getCountriesDataThunk = createAsyncThunk(
  'countries/data',
  async (_, thunkAPI) => {
    try {
      const response = await fetchData('countries', 'get');
      return thunkAPI.fulfillWithValue(response.data.countries);
    } catch (err) {
      return thunkAPI.rejectWithValue();
    }
  },
);


export const checkLoginThunk = createAsyncThunk(
  'checkLogin',
  async (_, thunkAPI) => {
    try {
      const response = await fetchData('loginState', 'get', {});
      return thunkAPI.fulfillWithValue(response.data);
    } catch (err) {
      return thunkAPI.rejectWithValue();
    }
  },
);

export const logOutUserThunk = createAsyncThunk(
  'logOut',
  async (_, thunkAPI) => {
    try {
      const response = await fetchData('logOut', 'get', {});
      return thunkAPI.fulfillWithValue(response.data);
    } catch (err) {
      return thunkAPI.rejectWithValue();
    }
  },
);

export const registrationAsyncThunk = createAsyncThunk(
  'registration',
  async ({ userEmail, userPassword, deviceToken, state }, thunkAPI) => {
    try {
      const response = await fetchData(`${state === 'login' ? 'login' : 'register'}`, 'post', { userEmail, userPassword, deviceToken });
      localStorage.removeItem('profile')
      return thunkAPI.fulfillWithValue(response.data);
    } catch (err) {
      return thunkAPI.rejectWithValue();
    }
  },
);

export const forgetPasswordAsyncThunk = createAsyncThunk(
  'forgetPassword',
  async ({ email }, thunkAPI) => {
    try {
      const response = await fetchData('forgetPassword', 'post', { email });
      return thunkAPI.fulfillWithValue(response.data);
    } catch (err) {
      return thunkAPI.rejectWithValue();
    }
  },
);

export const resetPasswordAsyncThunk = createAsyncThunk(
  'resetPassword',
  async ({ id, token, password }, thunkAPI) => {
    try {
      const response = await fetchData(`resetPassword/${id}/${token}`, 'post', { password });
      return thunkAPI.fulfillWithValue(response.data);
    } catch (err) {
      return thunkAPI.rejectWithValue();
    }
  },
);
export const subscriptionAsyncThunk = createAsyncThunk(
  'subscription',
  async ({
    userId,
    paddle_customer_id,
    paddle_email,
    product_id,
    product_name,
    quantity,
    trial_period,
    status,
    transaction_id
  }, thunkAPI) => {
    try {
      const response = await fetchData(`subscription`, 'post', {
        userId,
        paddle_customer_id,
        paddle_email,
        product_id,
        product_name,
        quantity,
        trial_period,
        status,
        transaction_id
      });
      return thunkAPI.fulfillWithValue(response.data);
    } catch (err) {
      return thunkAPI.rejectWithValue();
    }
  },
);

export const userSlice = createSlice({
  name: 'user',
  initialState: {
    user: null,
    profiles: [],
    countries: [],
    selectedProfile: null,
    login: false,
    subscription: false
  },
  reducers: {
    updateSelectedProfile: (state, action) => {
      state.selectedProfile = action.payload;
      localStorage.setItem('profile', JSON.stringify(action.payload));
    },
    resetUser: (state) => {
      state.user = null;
      state.profiles = [];
      state.selectedProfile = null;
      state.login = false;
      state.subscription = false;
    },

    setProfiles: (state, action) => {
      state.profiles = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getUserDataThunk.fulfilled, (state, action) => {
        state.user = action.payload.user;
        state.login = action.payload.login;
        state.subscription = action.payload.subscription;
      })
      .addCase(getCountriesDataThunk.fulfilled, (state, action) => {
        state.countries = action.payload.sort((a, b) => a.country.localeCompare(b.country));
      })
      //.addCase(updateProfilesDataThunk.fulfilled, (state, action) => {
      //   state.user = action.payload.user;
      //   state.login = action.payload.login;
      //   state.subscription = action.payload.subscription;
      //})
      .addCase(checkLoginThunk.fulfilled, (state, action) => {
        state.login = action.payload.login;
        state.subscription = action.payload.subscription;
      
        if (action.payload.login) {
          state.user = action.payload.user;
        } else {
          state.user = null;
          state.selectedProfile = null;
          state.profiles = [];
      
          localStorage.removeItem('profile');
          localStorage.removeItem('days');
          localStorage.removeItem('streak');
          localStorage.removeItem('user');
        }
      })
      .addCase(logOutUserThunk.fulfilled, (state, action) => {
        state.user = null;
        state.login = false;
        state.subscription = false;
        state.profiles = [];
        state.selectedProfile = null;
        localStorage.removeItem('profile');
        localStorage.removeItem('days');
        localStorage.removeItem('streak');
        localStorage.removeItem('user');
      })
      .addCase(registrationAsyncThunk.fulfilled, (state, action) => {
        state.user = action.payload.user;
        state.login = action.payload.login;
        state.subscription = action.payload.subscription;

        if (action.payload.user?.country) {
          state.countries = [action.payload.user.country];
        }
      })
      .addCase(forgetPasswordAsyncThunk.fulfilled, (state, action) => {
      })
      .addCase(resetPasswordAsyncThunk.fulfilled, (state, action) => {
      })
      ///.addCase(deleteProfileDataThunk.fulfilled, (state, action) => {
      ///  state.user = action.payload.user;
      ///  state.login = action.payload.login;
      ///  state.subscription = action.payload.subscription;
      ///})
      .addCase(subscriptionAsyncThunk.fulfilled, (state, action) => {
        state.user = action.payload.user;
        state.login = action.payload.login;
        state.subscription = action.payload.subscription;
      })
      .addCase(fetchProfilesThunk.fulfilled, (state, action) => {
        state.profiles = action.payload;
      })

      .addCase(deleteProfileThunk.fulfilled, (state, action) => {
        state.profiles = state.profiles.filter(
          p => p._id !== action.payload
        );

        if (state.selectedProfile?._id === action.payload) {
          state.selectedProfile = null;
          localStorage.removeItem('profile');
        }
      })

  },
})

export const { updateSelectedProfile, resetUser, setProfiles } = userSlice.actions;

export default userSlice.reducer;